import React, { useEffect, useRef } from "react";
import * as d3 from "d3";
import { colorMap } from "./Utils";

const HeatMap = ({ data }) => {
  const svgRef = useRef(null);

  // Define the color scale based on the provided status values
  const colorScale = d3
    .scaleOrdinal()
    .domain(["STARTED", "NOT STARTED", "STRUGGLING", "COMPLETED"])
    .range([
      colorMap["STARTED"],
      colorMap["NOT STARTED"],
      colorMap["STRUGGLING"],
      colorMap["COMPLETED"],
    ]);

  useEffect(() => {
    // Get the dimensions of the screen to set the SVG width
    const screenWidth = 1000;
    const margin = { top: 100, right: 0, bottom: 50, left: 300 };
    const width = screenWidth - 100;
    const height = 600; // You can adjust the height as needed

    // Create the x and y scales
    const xScale = d3
      .scaleBand()
      .domain(data.map((d) => d.student))
      .range([0, width])
      .padding(0.05);

    const yScale = d3
      .scaleBand()
      .domain(data.map((d) => d.exercise))
      .range([height, 0])
      .padding(0.2);

    // Create the heatmap
    const svg = d3.select(svgRef.current);
    // Clear everything inside the SVG
    svg.selectAll("*").remove();

    svg.attr("width", screenWidth).attr("height", height);

    const g = svg
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    g.selectAll("rect")
      .data(data)
      .enter()
      .append("rect")
      .attr("x", (d) => xScale(d.student))
      .attr("y", (d) => yScale(d.exercise))
      .attr("width", xScale.bandwidth())
      .attr("height", yScale.bandwidth())
      .style("fill", (d) => colorScale(d.exerciseStatus));

    // Add x-axis with rotated text
    g.append("g")
      .call(d3.axisTop(xScale))
      .selectAll("text")
      .attr("transform", "rotate(-45)")
      .attr("text-anchor", "start")
      .style("font-size", "13px");

    // Add y-axis
    g.append("g")
      .call(d3.axisLeft(yScale))
      .selectAll("text")
      .style("font-size", "13px")
      .attr("max-width", "10px");
  }, [data, colorScale]);

  return (
    <div
      style={{
        padding: "40px",
        backgroundColor: "white",
        borderRadius: "10px",
      }}
    >
      <svg ref={svgRef} className="w-full h-[1200px]">
        {/* The heatmap will be rendered inside this SVG */}
      </svg>
    </div>
  );
};

export default HeatMap;
